import {
  FETCH_CASHBACK_EXTRACT,
  FETCH_CASHBACK_EXTRACT_DETAILS,
} from './CashbackExtractActions'

const INITIAL_STATE = {
  items: [],
  details: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: [],
  meta: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CASHBACK_EXTRACT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        filters: action.payload.filters,
        meta: action.payload.data.meta,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
      }
    case FETCH_CASHBACK_EXTRACT_DETAILS.SUCCESS:
      return {
        ...state,
        details: action.payload.data.data,
      }
    default:
      return state
  }
}

export const getCashbackExtractListData = state => {
  return {
    items: state.cashbackExtract.items,
    page: state.cashbackExtract.page,
    sizePerPage: state.cashbackExtract.sizePerPage,
    totalSize: state.cashbackExtract.totalSize,
  }
}
